import { TablePaginationConfig } from 'antd'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { IncidentPageHeader, IncidentTable } from '@/components/pages/Incidents'
import routes from '@/constants/routes'
import useQueryPage from '@/hooks/useQueryPage'
import { useIncident } from '@/pages/Incident/Incident.hooks'

const Incident = () => {
  const currentPage = useQueryPage()
  const navigate = useNavigate()

  const { page, pageSize, setPage, getIncident, incidentResponse, loading } = useIncident()
  const dataSource = incidentResponse?.items ?? []
  const totalItems = incidentResponse?.meta.totalItems || 0

  const handleChangePage = (config: TablePaginationConfig) => {
    setPage(config.current ?? page)
    navigate({
      pathname: routes.incident.path,
      search: `?page=${config.current ?? page}`,
    })
  }

  useEffect(() => {
    if (currentPage) {
      setPage(currentPage)
    }
  }, [currentPage, setPage])

  useEffect(() => {
    getIncident()
  }, [getIncident])

  return (
    <>
      <IncidentPageHeader />
      <IncidentTable {...{ dataSource, loading, page, totalItems, pageSize }} onChange={handleChangePage} />
    </>
  )
}

Incident.displayName = 'Incident'
export default Incident
